function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls1-1,.cls1-3{fill:none;}.cls1-2{clip-path:url(#clip-path);}.cls1-3{stroke:#231f20;stroke-width:4.16px;}.cls1-4{font-size:37.48px;}.cls1-10,.cls1-11,.cls1-12,.cls1-13,.cls1-14,.cls1-15,.cls1-16,.cls1-17,.cls1-18,.cls1-19,.cls1-20,.cls1-21,.cls1-22,.cls1-23,.cls1-4,.cls1-5,.cls1-6,.cls1-7,.cls1-8,.cls1-9{fill:#231f20;font-family:futura-pt, sans-serif;}.cls1-5{font-size:37.48px;}.cls1-6{font-size:37.48px;}.cls1-7{font-size:37.48px;}.cls1-8{font-size:37.48px;}.cls1-9{font-size:37.48px;}.cls1-10{font-size:37.48px;}.cls1-11{font-size:37.48px;}.cls1-12{font-size:37.48px;}.cls1-13{font-size:37.48px;}.cls1-14{font-size:37.48px;}.cls1-15{font-size:37.48px;}.cls1-16{font-size:37.48px;}.cls1-17{font-size:37.48px;}.cls1-18{font-size:37.48px;}.cls1-19{font-size:37.48px;}.cls1-20{font-size:37.48px;}.cls1-21{font-size:37.48px;}.cls1-22{font-size:37.48px;}.cls1-23{font-size:37.48px;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path4"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls1-1",
  x: 34,
  y: 34,
  width: 432,
  height: 432
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Artwork_1",
  "data-name": "Artwork 1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls1-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls1-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls1-3",
  d: "M297.72,413.74a170.55,170.55,0,1,0-211.45-116A170.53,170.53,0,0,0,297.72,413.74Z"
})), /*#__PURE__*/React.createElement("text", {
  className: "cls1-4",
  transform: "translate(127.28 146.33) rotate(124.89)"
}, "C"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-5",
  transform: "matrix(-0.43, 0.9, -0.9, -0.43, 111.26, 169.26)"
}, "O"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-6",
  transform: "matrix(-0.25, 0.97, -0.97, -0.25, 98.6, 196.31)"
}, "D"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-7",
  transform: "translate(91.6 223.36) rotate(94.6)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-8",
  transform: "matrix(0.09, 1, -1, 0.09, 89.17, 249.13)"
}, "R"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-9",
  transform: "translate(92.11 277.22) rotate(77.39)"
}), /*#__PURE__*/React.createElement("text", {
  className: "cls1-10",
  transform: "translate(94.28 288.88) rotate(71.57)"
}, "&"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-11",
  transform: "translate(102.98 313.57) rotate(64.32)"
}), /*#__PURE__*/React.createElement("text", {
  className: "cls1-12",
  transform: "translate(107.5 324.34) rotate(57.15)"
}, "G"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-13",
  transform: "translate(123.49 348.85) rotate(47.29)"
}, "A"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-14",
  transform: "translate(140.6 368.12) rotate(36.26)"
}, "M"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-15",
  transform: "translate(166.54 387.06) rotate(26.71)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-16",
  transform: "translate(190.17 398.47) rotate(19.87)"
}), /*#__PURE__*/React.createElement("text", {
  className: "cls1-17",
  transform: "translate(201.01 402.9) rotate(12.99)"
}, "D"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-18",
  transform: "translate(228.24 409.07) rotate(3.19)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-19",
  transform: "matrix(0.99, -0.12, 0.12, 0.99, 254.05, 410.7)"
}, "S"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-9",
  transform: "translate(280.21 407.22) rotate(-12.61)"
}, "I"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-20",
  transform: "translate(291.68 405.1) rotate(-19.89)"
}, "G"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-21",
  transform: "translate(319.71 394.95) rotate(-31.43)"
}, "N"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-22",
  transform: "translate(343.73 380.66) rotate(-41.31)"
}, "E"), /*#__PURE__*/React.createElement("text", {
  className: "cls1-23",
  transform: "translate(363.42 363.57) rotate(-49.63)"
}, "R")));
function SvgLogoInner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1fdfas",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInner);
export default __webpack_public_path__ + "static/media/LogoInner.3e8f9f0e.svg";
export { ForwardRef as ReactComponent };